module.exports = __webpack_public_path__ + "static/media/background-dawn-dusk-silhouette.bd5269c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-dawn-dusk-silhouette.jpg
// module id = 1742
// module chunks = 0